module.exports = __webpack_public_path__ + "img/enmacc-logo.68032950.png";